import { useInsiderState } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderState";
export var useShowEligibleInsiderMessaging = function() {
    var _useInsiderState = useInsiderState(), isInsiderEligible = _useInsiderState.isInsiderEligible, isInsiderCancelled = _useInsiderState.isInsiderCancelled;
    var showEligibleInsiderMessaging = isInsiderEligible || isInsiderCancelled;
    return {
        showEligibleInsiderMessaging: showEligibleInsiderMessaging
    };
};
